export function Placeholder() {
	return (
		<div className="wp-block-steam-blocks-favorites__placeholder">
			<h1 className="has-fluid-2-font-size">
				Aktualnie nie masz zapisanych ofert.
			</h1>

			<div className="wp-block-steam-blocks-favorites__placeholder-content">
				<span className="wp-block-steam-blocks-favorites__zeros">0000</span>

				<div className="wp-block-steam-blocks-favorites__placeholder-info">
					<span>
						Zrób pierwszy krok i znajdź pracę klasy S: szybko dostępną, solidną
						i satysfakcjonującą.
					</span>

					<div className="wp-block-button">
						<a
							className="wp-block-button__link wp-element-button"
							href="/pl/offers/search/"
						>
							Szukaj ofert
						</a>
					</div>
				</div>
			</div>
		</div>
	);
}
